/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Settlement_Transfer_AmountInputs */

const vi_order_settlement_transfer_amount = /** @type {(inputs: Order_Settlement_Transfer_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền khách đã chuyển vào TK tài xế`)
};

/**

* @param {Order_Settlement_Transfer_AmountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_transfer_amount = /** @type {((inputs?: Order_Settlement_Transfer_AmountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_Transfer_AmountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_transfer_amount(inputs)
});